class DataUtil {
  static isJsonString = (str) => {
    if ( typeof str !== "string" )
    {
      return false;
    }

    let oParsedJSON;

    try
    {
      oParsedJSON = JSON.parse(str);
    } catch (e)
    {
      return false;
    }

    return oParsedJSON;
  };

  static isValidEmail = (email) => {
    let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(String(email).toLowerCase());
  };

  static convertToArray = (oInput) => {
    if ( typeof oInput === "string" ) return [oInput];
    if ( typeof oInput === "boolean" ) return [oInput];
    if ( typeof oInput === "number" ) return [oInput];
    if ( typeof oInput === "undefined" ) return [];

    if ( Array.isArray(oInput) ) return oInput;
    return [];
  };

  static convertToBoolean = (oInput) => {
    if ( typeof oInput === "undefined" ) return null;
    if ( oInput === true || oInput === "1" || oInput === 1 ) return true;
    if ( oInput === false || oInput === "0" || oInput === 0 ) return false;
    return null;
  };

  // http://www.nicnocquee.com/2017/02/24/resolve-keypath-immutablejs.html
  static resolveKeyPaths = (source, keypaths) => {
    const isFunction = (obj) => {
      return !!(obj && obj.constructor && obj.call && obj.apply);
    };

    const resolvedKeyPaths = [];

    keypaths.forEach((value, index) => {
      if ( isFunction(value) )
      {
        let subSource = source;

        if ( resolvedKeyPaths.length > 0 )
        {
          subSource = source.getIn(resolvedKeyPaths);
        }

        const indexToAdd = subSource.findIndex(value);

        if ( indexToAdd > -1 )
        {
          resolvedKeyPaths.push(indexToAdd)
        }
        else
        {
          console.error(`Cannot find index using ${value.toString()}`);
          throw `Error in ${index}th keypath`;
        }
      }
      else
      {
        resolvedKeyPaths.push(value);
      }
    });

    return resolvedKeyPaths
  }
}

export default DataUtil;